

















































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import SearchResultsCount from '../components/shared/SearchResultsCount.vue';

@Component({
    computed: {
        ...mapState(['config', 'searchFailed', 'searchLoading', 'searchResultsCount']),
        ...mapGetters('scope', ['filteredScopeLinks'])
    },
    components: {
        SearchResultsCount
    }
})
export default class BaseSearchLayout extends Vue {
    get disableFiltering(): boolean {
        return this.$store.state.config.disableFiltering;
    }

    get addMargin(): boolean {
        return !this.$store.state.initialSearchCallExecuted;
    }

    get showCount(): boolean {
        let searchResultsCount = this.$store.state.searchResultsCount;
        let searchFailed = this.$store.state.searchFailed;
        let filteredScopeLinks = this.$store.getters['scope/filteredScopeLinks'];
        
        return searchResultsCount > 0 && !searchFailed && !(filteredScopeLinks && filteredScopeLinks.length);
    }
}
